import { object, number, string } from 'yup';
import { ID_CONJUGADO } from '../../../pages/Beneficios/components/Renda/utils';

export const rendaConversaoSchema = object({
  tipoRendaMensal: string().required('O tipo de renda mensal é obrigatório'),
  percentualSaldoVitalicio: number().when('tipoRendaMensal', {
    is: ID_CONJUGADO,
    then: number()
      .required()
      .min(50, 'Valor mínimo: 50%')
      .max(99, 'Valor máximo: 99%'),
  }),
  percentualrcm: number()
    .required()
    .min(0, 'Valor mínimo: 0%')
    .max(100, 'Valor máximo: 100%'),

  percentualRendaMensal: number().when('tipoRendaMensal', {
    is: ID_CONJUGADO,
    then: number()
      .float(2, 'Máximo de duas casas decimais')
      .min(0.1, 'Valor mínimo permitido: 0.10%')
      .max(1, `Valor máximo permitido: 1%`)
      .typeError('Favor trocar vírgula (,) por ponto (.)')
      .required(`Insira um valor entre 0.10% e  1%`),
  }),
});

export class RendaConversaoModel {
  tipoRendaMensal = '';

  percentualSaldoVitalicio = '';

  percentualrcm = '';

  percentualRendaMensal = 0;

  beneficiariosChecked = [];
}
